import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { DatePickerFieldWUT } from '../../../ui/date-picker-field';
export const DatePickerWUT = props => {
  const fieldType = FIELD_TYPES.DATE_PICKER;
  return /*#__PURE__*/React.createElement(DatePickerFieldWUT, _extends({}, props, {
    fieldType: fieldType
  }));
};
//# sourceMappingURL=date-picker-wut.js.map